// Libraries
import styled from 'styled-components';

// Components
import { Table } from 'antd';
import { Row } from 'components/layout';

import Program from 'models/Program';

export const capitalizedStatus = string => string.charAt(0).toUpperCase() + string.slice(1);

export const INITIAL_SELECTION = {
  selectedRowKeys: [],
  selectedProjects: [],
  all: false,
};

export const getActualStage = currentStage => {
  const applicationStages = [
    Program.PROGRAM_STAGE_APPLICATION,
    Program.PROGRAM_STAGE_SELECTION,
    Program.PROGRAM_STAGE_APPROVED,
  ];
  if (applicationStages.includes(currentStage)) return Program.PROGRAM_STAGE_APPLICATION;
  return currentStage;
};

// Default styles for Entrepreneur and Mentor Table
// TODO: mode to a style file. Utils should be reserved for functions
export const StyledTable = styled(Table)`
  // Table head
  .anticon-filter:hover,
  .ant-table-thead,
  .ant-table-filter-icon:hover {
    background: transparent !important;
  }

  .ant-table-column-sorters:hover::before {
    background: transparent !important;
  }

  ${
    '' /* .ant-table-column-title {
    
  } */
  }

  .ant-table-column-sorter:hover i {
    color: rgba(0, 0, 0, 0.45);
  }

  .ant-table-thead > tr > th:not(.ant-table-selection-column):hover {
    background: #f2f2f2 !important;
  }

  // Table body
  .ant-table-tbody {
    background: #fff;
  }

  .ant-table-row-collapsed::after {
    content: 'ᐳ';
  }

  .ant-table-row-expand-icon {
    background-color: transparent;
    border: none;
    right: 0;
    position: absolute;
    top: 50%;
    transform: translateY(-50%);
  }

  .ant-table-row-expanded::after {
    content: 'ᐱ';
  }

  tr.ant-table-row td:nth-child(2) {
    position: relative;
  }

  .ant-table-selection-column {
    padding: 16px 16px 16px 30px;
  }

  .ant-checkbox-checked .ant-checkbox-inner {
    background-color: #00ffaf !important;
    border-color: #00ffaf !important;
    transform: scale(1.3);

    &::after {
      background-color: #00ffaf;
    }
  }

  .ant-table-pagination.ant-pagination {
    margin: 16px 16px;
  }
`;

// Default styles for Row in Entrepreneur and Mentor Table
export const StyledRow = styled(Row)`
  padding: 20px 30px;
  background: #fff;
  width: 110%;
`;
